import React, { useState } from "react";
import { Card, Container, Row, Col, Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";


function IntegratedSecurity() {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [gallery, setGallery] = useState(false);
    const [activeImage, setActiveImage] = useState(false);
    return (
        <>
            <div className="product">
                <div class="container-fluid bg-dark p-0">
                    <div class="row gx-0 d-none d-lg-flex">
                        <div class="col-lg-7 px-5 text-start">
                            <div class="h-100 d-inline-flex align-items-center me-4">
                                <small class="fa fa-map-marker-alt text-primary me-2"></small>
                                <small>Opposite Safron Landmark, Beed Bypass, Aurangabad-431010</small>
                            </div>
                            <div class="h-100 d-inline-flex align-items-center">
                                <small class="far fa-clock text-primary me-2"></small>
                                <small>Mon - Fri : 09.00 AM - 09.00 PM</small>
                            </div>
                        </div>
                        <div class="col-lg-5 px-5 text-end">
                            <div class="h-100 d-inline-flex align-items-center me-4">
                                <small class="fa fa-phone-alt text-primary me-2"></small>
                                <small>+012 345 6789</small>
                            </div>
                            <div class="h-100 d-inline-flex align-items-center mx-n2">
                                <a class="btn btn-square btn-link rounded-0 border-0 border-end border-secondary" href=""><i class="fab fa-facebook-f"></i></a>
                                <a class="btn btn-square btn-link rounded-0 border-0 border-end border-secondary" href=""><i class="fab fa-twitter"></i></a>
                                <a class="btn btn-square btn-link rounded-0 border-0 border-end border-secondary" href=""><i class="fab fa-linkedin-in"></i></a>
                                <a class="btn btn-square btn-link rounded-0" href=""><i class="fab fa-instagram"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Topbar End --> */}


                {/* <!-- Navbar Start --> */}
                <nav class="navbar navbar-expand-lg bg-white navbar-light sticky-top p-0">
                <a href="index.html" class="navbar-brand d-flex align-items-center border-end px-4 px-lg-5">
                    <img src="img/logo.jpeg" width="100" />
                </a>
                <button type="button" class="navbar-toggler me-4" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarCollapse">
                    <div class="navbar-nav ms-auto p-4 p-lg-0">
                        <Link to="/"><a href="/" class="nav-item nav-link active">Home</a></Link>
                        <Link to="/about"> <a href="/about" class="nav-item nav-link">About</a></Link>
                        <div class="nav-item dropdown">
                            <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">Service</a>
                            <div class="dropdown-menu bg-light m-0">
                            <Link to="/enginerringServices" style={{marginBottom:'1em'}}><a class="h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2" href="/enginerringServices"><i class="bi bi-arrow-right me-2"></i>Engineering and Consultancy Service</a></Link>
                                <Link to="/fireHydrant" style={{marginBottom:'1em'}}><a class="h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2" href="/fireHydrant"><i class="bi bi-arrow-right me-2"></i>Fire Hydrant System</a></Link>
                                <Link to="/firesprinkler" style={{marginBottom:'1em'}}><a class="h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2" href="/firesprinkler"><i class="bi bi-arrow-right me-2"></i>Fire Sprinkler System</a></Link>
                                <Link to="/fireAlarm" style={{marginBottom:'1em'}}> <a class="h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2" href="/fireAlarm"><i class="bi bi-arrow-right me-2"></i>Fire Alarm and Detection System</a></Link>
                                <Link to="/publicAddress" style={{marginBottom:'1em'}}><a class="h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2" href="publicAddress"><i class="bi bi-arrow-right me-2"></i>Public Address System</a></Link>
                                <Link to="/accessControl" style={{marginBottom:'1em'}}><a class="h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2" href="/accessControl"><i class="bi bi-arrow-right me-2"></i>Access Control System</a></Link>
                                <Link to="/transformerProtection" style={{marginBottom:'1em'}}><a class="h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2" href="/transformerProtection"><i class="bi bi-arrow-right me-2"></i>Transformer Protection System</a></Link>
                                <Link to="/integratedSecurity" style={{marginBottom:'1em'}}><a class="h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2" href="/integratedSecurity"><i class="bi bi-arrow-right me-2"></i>Integrated Security System</a></Link>
                            </div>
                        </div>
                        <Link to="/contact"> <a href="/contact" class="nav-item nav-link">Contact</a></Link> 
                    </div>
                </div>
            </nav>
                {/* <!-- Navbar End --> */}

                {/* <!-- Page Header Start --> */}
                <div class="container-fluid page-header py-5 mb-5">
                    <div class="container py-5">
                        <h1 class="display-3 text-white mb-3 animated slideInDown">Integrated Security System</h1>
                        <nav aria-label="breadcrumb animated slideInDown">

                        </nav>
                    </div>
                </div>
                {/* <!-- Page Header End --> */}
                <div className="row">
                    <div class="col-lg-4">
                        {/* <!-- Search Form Start --> */}
                        {/* <div class="mb-5 wow slideInUp" data-wow-delay="0.1s">
                        <div class="input-group">
                            <input type="text" class="form-control p-3" placeholder="Keyword" />
                            <button class="btn btn-primary px-4"><i class="bi bi-search"></i></button>
                        </div>
                    </div> */}
                        {/* <!-- Search Form End --> */}

                        {/* <!-- Category Start --> */}
                        <div class="mb-5 wow slideInUp" data-wow-delay="0.1s" style={{ border: '1px solid', margin: '10px' }}>
                            <div class="section-title section-title-sm position-relative pb-3 mb-4">
                                <h3 class="mb-0">Categories</h3>
                            </div>
                            <hr />
                            <div class="link-animated d-flex flex-column justify-content-start">
                                <a class="h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2" href="/enginerringServices"><i class="bi bi-arrow-right me-2"></i>Engineering and Consultancy Service</a>
                                <a class="h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2" href="/fireHydrant"><i class="bi bi-arrow-right me-2"></i>Fire Hydrant System</a>
                                <a class="h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2" href="/firesprinkler"><i class="bi bi-arrow-right me-2"></i>Fire Sprinkler System</a>
                                <a class="h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2" href="/fireAlarm"><i class="bi bi-arrow-right me-2"></i>Fire Alarm and Detection System</a>
                                <a class="h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2" href="publicAddress"><i class="bi bi-arrow-right me-2"></i>Public Address System</a>
                                <a class="h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2" href="/accessControl"><i class="bi bi-arrow-right me-2"></i>Access Control System</a>
                                <a class="h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2" href="/transformerProtection"><i class="bi bi-arrow-right me-2"></i>Transformer Protection System</a>
                                <a class="h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2" href="/integratedSecurity"><i class="bi bi-arrow-right me-2"></i>Integrated Security System</a>
                            </div>
                        </div>
                        {/* <!-- Category End --> */}

                    </div>
                    {/* <!-- Sidebar End --> */}

                    <div className="col-lg-8">
                        <div class="image">
                            <img src="./img/integrated.jpg" style={{ width: '800px', height: '300px' }} class="img-fluid" alt="" />
                        </div>
                        <h1 style={{ padding:'10px' }}>Integrated Security System</h1>
                        <p style={{ color: 'black',padding:'10px' }}>Integration of alarm system components provides valuable protection to many types of properties whether a small business, a storage warehouse, industrial manufacturing, or high-rise hotels. Quick detection and response to various threats whether a fire or security risk is necessary to protect people and property. Integration of safety and security systems provides many benefits to business owners with comprehensive protection.</p>
                        <p style={{ color: 'black',padding:'10px' }}>Additional benefits include cost savings and easy upgrades when working with experienced fire and life safety consultants and non proprietary fire alarm equipment. Components of an integrated alarm system include:
                        </p>
                        <p style={{ color: 'black',padding:'10px' }}>
                            1) Fire safety with notification and detection devices<br />
                            2) Security systems such as secure access and mass notification systems<br />
                            3) Video surveillance provides valuable protection with wireless cameras, night-vision, recording capabilities and easy installation<br />
                            4) Continual monitoring provides reliable dispatch to emergency personnel<br />
                            5) Evacuation procedures and equipment such as audible evacuation equipment helps direct occupants to safety
                        </p>
                    </div>
                </div>
                {/* <!-- ======= Footer ======= --> */}
                <div class="container-fluid bg-dark text-body footer mt-5 pt-5 wow fadeIn" data-wow-delay="0.1s">
                <div class="container py-5">
                    <div class="row g-5">
                        <div class="col-lg-3 col-md-6">
                            <h5 class="text-white mb-4">Address</h5>
                            <p class="mb-2"><i class="fa fa-map-marker-alt me-3"></i>Office no-611, Vastu Elite Square,, Opposite Safron Landmark, Beed Bypass, Aurangabad-431010
                                <br/>Email-services@ssfireengineers.com
                                <br/>Phone:- 77981 21291</p>
                            <div class="d-flex pt-2">
                                <a class="btn btn-square btn-outline-light btn-social" href=""><i class="fab fa-twitter"></i></a>
                                <a class="btn btn-square btn-outline-light btn-social" href=""><i class="fab fa-facebook-f"></i></a>
                                <a class="btn btn-square btn-outline-light btn-social" href=""><i class="fab fa-youtube"></i></a>
                                <a class="btn btn-square btn-outline-light btn-social" href=""><i class="fab fa-linkedin-in"></i></a>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                            <h5 class="text-white mb-4">Quick Links</h5>
                            <a class="btn btn-link" href="/">Home</a>
                            <a class="btn btn-link" href="/about">About Us</a>
                            <a class="btn btn-link" href="/contact">Contact Us</a>
                        </div>

                        <div class="col-lg-3 col-md-6">
                            <h5 class="text-white mb-4">Newsletter</h5>
                            <div class="position-relative mx-auto" style={{ maxwidth: '400px' }}>
                                <input class="form-control border-0 w-100 py-3 ps-4 pe-5" type="text" placeholder="Your email" />
                                <button type="button" class="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2">SignUp</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container">
                    <div class="copyright">
                        <div class="row">
                            <div class="col-md-6 text-center text-md-start mb-3 mb-md-0">
                                &copy; <a href="#">SS FIRE ENGINEERS</a>, All Right Reserved.
                            </div>
                            <div class="col-md-6 text-center text-md-end">
                                {/* This template is free as long as you keep the footer author’s credit link/attribution link/backlink. If you'd like to use the template without the footer author’s credit link/attribution link/backlink, you can purchase the Credit Removal License from "https://htmlcodex.com/credit-removal". Thank you for your support.  */}
                                Designed By <a href="#">BFI</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                {/* <!-- End Footer --> */}
            </div>
        </>
    );
}

export default IntegratedSecurity;

